import { css } from '@microsoft/fast-element';

export default css`
	:host {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(min(100%, var(--grid-min, 30ch)), 1fr));
		gap: var(--padding-md);
	}
`;